import styled from '@emotion/styled';
import ScreenSize from '../../constants/screen-sizes';

export const StyledItemList = styled.div`
  width: 100%;
  display: grid;
  align-items: left;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  justify-content: start;

  @media screen and (max-width: ${ScreenSize.SMALL_SCREEN}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
